import React, { useState } from 'react';
import { Button, Modal, Form, Input } from 'antd';
import {EditOutlined} from '@ant-design/icons';

const AuctionUpdateForm = ({ visible, onCreate, onCancel, record }) => {

  let auction = record
  const [form] = Form.useForm();
  const [auctionID]=useState(auction.AuctionID)
  const [auctionName]=useState(auction.AuctionName)
  const [auctionAddress]=useState(auction.AuctionAddress)
  const [auctionWebsite]=useState(auction.AuctionWebsite)
  const [auctionPhone]=useState(auction.AuctionPhone)

  return (
    <Modal
      visible={visible}
      title="Update Auction"
      okText="Update"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="AuctionUpdate"
        initialValues={{
            AuctionID:auctionID,
            AuctionName:auctionName,
            AuctionAddress:auctionAddress,
            AuctionWebsite:auctionWebsite,
            AuctionPhone:auctionPhone,
        }}
      >
        <Form.Item
          name="AuctionID"
          label="Auction ID"
        >
            <Input disabled/>
        </Form.Item>
        <Form.Item
          name="AuctionName"
          label="Auction Name"
        >
          <Input />
        </Form.Item>
        <Form.Item name="AuctionAddress" label="Auction Address">
          <Input />
        </Form.Item>
        <Form.Item name='AuctionWebsite' label="Auction Website">
            <Input />
        </Form.Item>
        <Form.Item name='AuctionPhone' label="Auction Phone">
            <Input addonBefore={'+1'}/>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const AuctionUpdate = (props) => {
  const [visible, setVisible] = useState(false);
  const onCreate = (values) => {
    props.updateAuction(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
        icon={<EditOutlined />}
      >
      </Button>
      <AuctionUpdateForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
        record={props.record}
      />
    </div>
  );
};

export default AuctionUpdate